module.exports = __webpack_public_path__ + "static/media/raze.558e78c6.png";